export default "__VITE_ASSET__Cwst_CFL__"